// src/components/ErrorDisplay.js
import React from 'react';

const ErrorDisplay = ({ error }) => (
  <div className="error-container">
    <h2>An error occurred</h2>
    <p>{error.message || 'Unknown error'}</p>
  </div>
);

export default ErrorDisplay;